import 'core-js/features/reflect';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app.module';
import { setTheme } from 'ngx-bootstrap/utils';
import { AdminResourceEditPageBase } from './common/controller/admin-resource-edit-page-base';
import { setUserProfileSaverInjector } from '../components/session/user-profile-saver.service';

// Capture deeper stacks for Rollbar / console before anything else throws.
if (typeof Error !== 'undefined' && (Error as any).stackTraceLimit < 50) {
  (Error as any).stackTraceLimit = 50;
}

// Do not call enableProdMode(): keep ExpressionChanged / NG0100 checks active
// in deploy builds so binding races surface in Rollbar (via ErrorHandler).

setTheme('bs5');

platformBrowserDynamic().bootstrapModule(AppModule).then(ref => {
  AdminResourceEditPageBase.injector = ref.injector;
  setUserProfileSaverInjector(ref.injector);
});
